<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Historia zmian
                </h1>
            </v-card-title>

            <v-card-text class="job-change-history-dialog__content">
                <div class="job-change-history-dialog__scroll">
                    <v-data-table
                        :headers="headers"
                        :items="history"
                        :loading="isLoading"
                        hide-default-footer
                        disable-pagination
                        :mobile-breakpoint="0"
                    >
                        <template #item.user="{item}">
                            {{ item.user.firstName }} {{ item.user.lastName }}
                        </template>
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                        <template #no-data>
                            <p class="text-center my-4">
                                Brak danych
                            </p>
                        </template>
                    </v-data-table>
                </div>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij historię zmian zlecenia"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'JobChangeHistoryDialog',
    mixins: [dateFormatter],
    props: {
        isOpen: {
            type: Boolean
        },
        isLoading: {
            type: Boolean
        },
        history: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Kto',
                    sortable: false,
                    value: 'user'
                },
                {
                    text: 'Kiedy',
                    align: 'center',
                    sortable: false,
                    value: 'createdAt'
                }
            ]
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>

<style scoped>

.job-change-history-dialog__scroll {
    max-height: 60vh;
    overflow-y: auto;
}
</style>
